/**
 * Stable marker class on notistack's snackbar container. Its own container class is a generated JSS
 * name, so it cannot be matched against; this one is applied in `ToastContextProvider`.
 */
export const TOAST_CONTAINER_CLASS_NAME = 'dfh-toast-container'

/** Whether an event target sits inside the toast container. */
export const isWithinToastContainer = (target: EventTarget | null): boolean =>
  target instanceof Element && !!target.closest(`.${TOAST_CONTAINER_CLASS_NAME}`)
